import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  useEffect(() => { api.get("/messages").then((r) => setMessages(r.data)); }, []);
  return (
    <div>
      <h1 className="font-serif-display text-4xl mb-8">Messages</h1>
      <div className="space-y-3">
        {messages.map((m) => (
          <div key={m.id} className="bg-white border border-brand-border rounded-sm p-5" data-testid={`admin-message-${m.id}`}>
            <div className="flex items-center justify-between gap-4 mb-1">
              <h4 className="font-serif-display text-lg">{m.subject || "Contact form enquiry"}</h4>
              <span className="text-xs text-muted-foreground whitespace-nowrap">{m.created_at ? new Date(m.created_at).toLocaleString("en-GB") : ""}</span>
            </div>
            <p className="text-sm mb-2"><span className="font-medium">{m.name}</span> · <a href={`mailto:${m.email}`} className="text-brand-pink underline">{m.email}</a></p>
            <p className="text-sm text-muted-foreground whitespace-pre-line">{m.message}</p>
            <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject || "Your enquiry")}`} className="inline-flex items-center gap-1.5 mt-3 text-xs uppercase tracking-luxe text-brand-ink hover:text-brand-pink" data-testid={`reply-${m.id}`}><Mail className="w-3.5 h-3.5" /> Reply</a>
          </div>
        ))}
        {messages.length === 0 && <p className="text-sm text-muted-foreground">No messages yet.</p>}
      </div>
    </div>
  );
}
